import { render, staticRenderFns } from "./FirmaTanimliAlanlarStockView.vue?vue&type=template&id=203c67cc&"
import script from "./FirmaTanimliAlanlarStockView.vue?vue&type=script&lang=js&"
export * from "./FirmaTanimliAlanlarStockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports